import * as React from 'react'

import { useTranslation } from '../../../hooks/useTranslation'
import { Button } from '../../../lib/ui/button'
import { FilterButton } from '~/components/shared/Buttons'
import useFilters from '~/components/shared/useFilters'

export function Filters() {
  const { t } = useTranslation('Filter')
  const { filterValues, clearFilters } = useFilters()

  return (
    <div className="flex items-center gap-4 max-md:flex-wrap">
      {filterValues.map((filterValue) => (
        <Filter key={filterValue} filterValue={filterValue} />
      ))}
      <Button onClick={clearFilters} variant="link">
        {t('clear')}
      </Button>
    </div>
  )
}

const Filter = ({ filterValue }) => {
  const { t } = useTranslation('Filter')
  const { isActive, handleFilterClick } = useFilters()

  const active = isActive(filterValue)

  const handleClick = () => {
    handleFilterClick(filterValue)
  }

  return (
    <FilterButton active={active} onClick={handleClick}>
      {t(filterValue)}
    </FilterButton>
  )
}
